// removed by extract-text-webpack-plugin
module.exports = {"content":"PageHeaderLayout__content__2Qldd"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageHeaderLayout.less
// module id = 1308
// module chunks = 0